import type { ReactNode } from "react"
import classnames from "classnames"
import { BadgeSizes, BadgeThemes } from "./types"

interface BadgeWrapperProps {
  children: ReactNode
  size: BadgeSizes
  theme: BadgeThemes | "featured"
}

export const BadgeWrapper = ({ size, theme, children }: BadgeWrapperProps) => {
  return (
    <span className={classnames("badge", `${theme}-badge`, `${size}-badge`)}>
      {children}
    </span>
  )
}
